<template>
  <div class="home_box flex_all">
    <!-- <Login></Login> -->
    <div class="login_moni" @click="showTempLogin" v-if="baseUrl.indexOf('pre-supplier.shopvidi.com') != -1 || baseUrl.indexOf('localhost:')!=-1 ">模拟登录</div>
    <div class="login_box flex">
      <div class="login_left">
        <p class="info">
          <span>ShopVidi</span> - Global Brands, Local Retailers, One
          Entrepreneur Dream!
        </p>
        <img
          class="login_img"
          src="https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-login_img.png"
          alt=""
        />
        <div class="icon_line_box">
          <div class="icon_line flex">
            <img
              class="icon_img"
              src="https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line1.png"
              alt=""
            />
            <p class="text_p2">Access to numerous retailers across the states</p>
          </div>
          <div class="icon_line flex">
            <img
              class="icon_img"
              src="https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line2.png"
              alt=""
            />
            <p class="text_p2">Guaranteed payments on every order</p>
          </div>
          <div class="icon_line flex">
            <img
              class="icon_img"
              src="https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line3.png"
              alt=""
            />
            <p class="text_p2">Risk-free terms extended to retailers</p>
          </div>
          <div class="icon_line flex">
            <img
              class="icon_img"
              src="https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line4.png"
              alt=""
            />
            <p class="text_p2">Retailer veriﬁcation, payment collection, & customer support</p>
          </div>
          <div class="icon_line flex">
            <img
              class="icon_img"
              src="https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line5.png"
              alt=""
            />
            <p class="text_p2">Analytics, and tools to streamline your business</p>
          </div>
        </div>
      </div>
      <div class="login_right">
        <!-- <img class="shopvidi_logo" src="https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-shopvidi_logo.png" alt=""> -->
        <img class="shopvidi_logo" src="@/assets/img/shopvidi_logo.png" alt="" />
        <el-form :model="loginForm" ref="loginForm" >
          <el-form-item
            prop="email"
            :rules="[
              {
                required: true,
                message: 'Please enter the email',
                trigger: 'blur',
              },
              {
                type: 'email',
                message: 'Please enter the correct email address or password',
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-input v-model="loginForm.email" placeholder="Email"></el-input>
          </el-form-item>
          <el-form-item
            prop="password"
            :rules="{
              required: true,
              message: 'Please enter the correct email address or password',
              trigger: 'blur',
            }"
          >
            <el-input
              v-model="loginForm.password"
              type="text"
              @focus="changeType"
              placeholder="Password"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="loginForm.remember" style="width:100%;padding-left: 35px;">Remember</el-checkbox>
            <div class="forget-btn" @click="$router.push('/forget')">
              Forgot password?
            </div>
          </el-form-item>
          <el-form-item>
            <p class="text_agreen">By clicking Login, you agree to our <a href="https://www.shopvidi.com/term-service"><span class="organ_color" >Terms of Service</span></a></p>
          </el-form-item>
          <el-form-item
            ><el-button
              type="primary"
              @click="submitForm('loginForm')"
              class="btn"
              >Login</el-button
            ></el-form-item
          >
          <el-form-item v-if="!isPartner">
            <div class="brand_register"  @click="changeForm('register')">Brand Register</div>
          </el-form-item>
          <el-form-item v-if="isPartner">
            <div class="register"  @click="changeForm('register')">Register</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-dialog
      :visible.sync="showTempLoginDialog"
      :destroy-on-close="true"
      width="880px"
      :append-to-body="true"
      class="wap"
    >
      <div style="width:90%;padding:20px">
        <el-input v-model="email" placeholder="email" auto-complete="new-password" style="margin:30px 0px"></el-input>
        <el-input v-model="password" placeholder="password" auto-complete="new-password" :type="passw" style="margin-bottom:20px;">
          <i slot="suffix" @click="showPass">
            <img
              v-if="passw=='password'"
              style="width:25px;height:25px"
              src="../../assets/img/icon-hide.png"
              alt="" />
            <img
              v-else
              style="width:25px;height:25px"
              src="../../assets/img/icon-show.png"
              alt="" />
          </i>
        </el-input>
        <el-button @click="tempLogin">Login</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { postAction, getAction } from '@/api/manage.js'
import {loadSysRole} from '../components/loadSysRole.js'
export default {
  name: 'Home',
  data() {
    return {
      baseUrl: '',
      showTempLoginDialog: false,
      email: '', // 模拟登录
      password: '', // 模拟登录
      passw: 'password',
      loginForm: {
        email: '',
        password: '',
        remember: false
      }
    }
  },
  created() {
    this.baseUrl = window.location.origin
    gtag('event', 'conversion', {'send_to': 'AW-10872160881/iKr4CKfT66sDEPGEoMAo'})
    gtag('event', 'conversion', {'send_to': 'AW-301131205/cYGMCNH0ybIDEMXLy48B'})
    gtag('event', 'conversion', {'send_to': 'AW-342118137/59c2CI3FsuMCEPmdkaMB'})
    gtag('event', 'conversion', {'send_to': 'AW-10888618638/gDZdCJbUmLYDEI7FjMgo'})
  },
  methods: {
    changeForm() {
      this.$router.push({path: '/register'})
    },
    loadSysRole() {
      loadSysRole(response => {
        const menuList = response
        let menu = menuList[0]
        if (menuList[0].childrenList && menuList[0].childrenList.length > 0) {
          menu = menuList[0].childrenList[0]
        }
        this.$router.push({path: 'menu/' + menu.key})
      })
    },
    showPass() {
      // 点击图标是密码隐藏或显示
      if (this.passw === 'text') {
        this.passw = 'password'
      } else {
        this.passw = 'text'
      }
    },
    showTempLogin() {
      this.showTempLoginDialog = true
    },
    // 跳转到商城的条款页面
    toServicePage() {
      window.location.href = 'https://www.shopvidi.com/term-service'
    },
    changeType(e) {
      e.srcElement.type = 'password'
    },
    async loginHandle() {
      let res = await postAction('/sys/login', {
        password: this.loginForm.password,
        remember_me: this.loginForm.remember,
        username: this.loginForm.email,
        loginEntry: 2
      })
      if (res.code == 200) {
        this.$ls.set('token', res.result.token)
        this.$ls.set('userInfo', res.result.userInfo)
        this.$ls.set('realname', res.result.userInfo.realname)
        Vue.prototype.login = true
        Vue.prototype.username = res.result.userInfo.firstName + res.result.userInfo.lastName
        // 登录成功后 先判断当前域名，如果是partner 那么就跳转review
        if (this.isPartner) {
          let userInfo = JSON.parse(localStorage.getItem('pro__userInfo')).value
          if (userInfo) {
            getAction('/brand/api/v0.2/businesses/' + userInfo.id).then(response => {
              if (response.success) {
                if (response.result.reviewStatus === 1) {
                  this.$router.push('/menu/procurement-orders')
                } else {
                  this.$router.push('/review')
                }
              }
            })
          }
        } else {
          // this.loadSysRole()
          getAction('/register/supplier/replenish').then(response => {
            if (response.success) {
              if (response.result) {
                // 如果是false的话就直接进入brand后台
                if (!response.result.supplierStep) {
                  this.loadSysRole()
                } else {
                  // 如果是true的话，看状态
                  const params = {}
                  if (response.result.supplierReviewStatus === 2) {
                    params.result = 'declined'
                  } else if (response.result.supplierReviewStatus === 1) {
                    params.result = 'approved'
                  } else if (response.result.supplierReviewStatus === 0) {
                    params.result = 'inReview'
                  } else {
                    params.result = 'profile'
                  }
                  this.$router.push({path: '/brand-review', query: params})
                }
              }
            } else {
              this.$message.warning(response.message)
            }
          })
        }
      } else {
        this.$message.warning(res.message)
      }
    },
    async submitForm(type) {
      if (type == 'loginForm') {
        this.$refs[type].validate(async (valid) => {
          if (valid) {
            this.loginHandle()
          }
        })
      }
    },
    async tempLogin() {
      let res = await postAction('/sys/temp-login?username=' + this.email + '&password=' + this.password)
      if (res.code === 200) {
        this.$ls.set('token', res.result.token)
        this.$ls.set('userInfo', res.result.userInfo)
        this.$ls.set('realname', res.result.userInfo.realname)
        Vue.prototype.login = true
        this.showTempLoginDialog = false
        this.$router.push({path: 'menu/Order'})
      } else {
        this.$message.warning(res.message)
      }
    }
  }
}
</script>

<style scoped lang="less">
.login_moni{
  position: fixed;
  top: 20px;
  right: 20px;
  width: 100px;
  height: 40px;
  background: #FB541C;
  color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  font-weight: bold;
  line-height: 40px;
  cursor: pointer;
}
/deep/ .el-input{
  width: 370px;
  height: 50px;
}
/deep/.el-button--primary{
  width: 370px;
 height: 50px;
 background: #262B2F;
 border: none;
 border-radius: 0;
}
/deep/.el-form-item__error{
  margin-left: 40px;
}
.text_agreen{
  width:100%;padding-left: 35px;margin-top:-28px;
  font-size: 14px;
  font-family: Graphik;
  font-weight: 400;
}
.organ_color{
  color: #FB541C;
  text-decoration:underline;
  cursor: pointer;
}
.home_box {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;
}
.login_box {
  width: 886px;
  height: 560px;
  background: rgba(255, 255, 255, 0.39);
  border: 1px solid #f0f0f0;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  .login_left,
  .login_right {
    flex: 1;
    .brand_register{
      width: 370px;
      text-align: left;
      margin-top: -10px;
      cursor: pointer;
      text-decoration: underline;
      font-family: Satoshi-Bold !important;
    }
  }
  .login_left {
    background: #efd2b5;
    border-radius: 10px 0 0 10px;
    position: relative;
    .info {
      position: absolute;
      left: 20px;
      top: 20px;
      width: 400px;
      text-align: left;
      font-size: 20px;
      font-family: Graphik;
      font-weight: 500;
      line-height: 36px;
      color: #262b2f;
      word-break: keep-all;

      span {
        font-size: 24px;
      }
    }
    .login_img {
      width: 380px;
      height: 315px;
      margin: 64px 0 0 25px;
    }
    .icon_line_box{
      margin-top: 17px;
    }
    .icon_line{
      margin: 0 0 2px 12px;
      align-items: center;
        .icon_img{
          width: 28px;
          height: 28px;
        }
        p{
          margin-left: 6px;
          line-height: 26px;
          font-size: 12px;
        }
      }

  }
  .shopvidi_logo{
    width: 175px;
    height: 45px;
    margin: 116px 0 44px 124px;
  }
}
.register{
  width: 80%;
  text-align: center;
  margin-top: -10px;
  cursor: pointer;
}
.forget-btn{
  width: 50%;
  cursor: pointer;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/login.vue